import React, { useState } from 'react';
import { Button, ActionList, Popover, Icon } from 'components/ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import { connect } from 'react-redux';
import * as templateActions from '../../../actions/editor/template';
import TemplateStatus from './TemplateStatus';

const TemplateStatusToggleButton = ({
  templateActive,
  onTemplateStatusChange,
  hasSectionsWithInvalidElements,
}) => {
  const [statusPopoverVisible, setStatusPopoverVisible] = useState(false);

  const handleStatusChange = status => {
    setStatusPopoverVisible(false);
    onTemplateStatusChange(status);
  };

  const actionListActivator = (
    <Button
      aria-label={t('templates.status_toggle.label')}
      className="TemplateStatusPopoverTrigger"
      data-testid="TemplateStatusPopoverTrigger"
      onClick={() => setStatusPopoverVisible(true)}
    >
      <TemplateStatus templateActive={templateActive} />
      <Icon name="caret_down" aria-label="Caret Down Icon" />
    </Button>
  );

  return (
    <div>
      <Popover
        className="TemplateStatusPopover"
        activator={actionListActivator}
        visible={statusPopoverVisible}
        align="right"
        onClose={() => setStatusPopoverVisible(false)}
      >
        <div className="TemplateStatusPopoverList">
          <ActionList
            items={[
              {
                content: (
                  <>
                    <TemplateStatus />
                    <Text
                      component="div"
                      className="ml-20"
                      variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
                    >
                      {t('templates.status_toggle.draft.description')}
                    </Text>
                  </>
                ),
                onClick: () => handleStatusChange(false),
              },
              {
                content: (
                  <>
                    <TemplateStatus templateActive />
                    <Text
                      component="div"
                      className="ml-20"
                      variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
                    >
                      {t('templates.status_toggle.active.description')}
                    </Text>
                  </>
                ),
                onClick: () => handleStatusChange(true),
                disabled: hasSectionsWithInvalidElements,
              },
            ]}
          />
        </div>
      </Popover>
    </div>
  );
};

const mapStateToProps = ({ editor }) => ({
  templateActive: editor.templateActive,
  hasSectionsWithInvalidElements: !!editor.sectionsWithInvalidElements.length,
});

const mapDispatchToProps = dispatch => ({
  onTemplateStatusChange(status) {
    dispatch(templateActions.requestStatusChange(status));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TemplateStatusToggleButton);
